import { financingProductsNames } from '@/constants/financing'
import type { TMessages } from '@/types/TMessages'

export const messages = {
  title: 'Остались вопросы по лизингу?',
  description: 'Ответим в течение часа рабочего дня',
  button: 'Получить консультацию',
  agreement: 'Ввод номера телефона подтверждает ваше согласие с <LinkToAgreement>политикой обработки персональных данных</LinkToAgreement>',
  form: {
    phone: {
      placeholder: 'Номер телефона',
      error: 'Необходимо заполнить',
    },
  },
  financingProductsNames,
} satisfies TMessages
